import commonFunc from "../common.func";
import constant from "../main.constants";
import moment from "moment";

let tableHelper = {
    createTableFromCreator(queryFrom, myThis) {
        if (localStorage.saveAsStringMap && localStorage.parameterEntityMaps) {
            const saveAsStringMap = JSON.parse(localStorage.saveAsStringMap);
            const parameterEntityMaps = commonFunc.getCompressedItem('parameterEntityMaps');
            if (queryFrom == "globalQuery") {
                myThis.maps = JSON.parse(JSON.stringify(myThis.tableData.data.complexResult));
            } else if (queryFrom == "dynamicTable") {
                myThis.maps = JSON.parse(JSON.stringify(myThis.tableMaps))
            } else {
                myThis.multiTableData = {};
                myThis.maps = JSON.parse(JSON.stringify(myThis.tableData.data));
            }
            let tabIndex = 0;
            Object.keys(myThis.maps.edgeMap).forEach(edge => {
                this.changeNumericParameterToString(myThis.maps.edgeMap[edge].properties, myThis.maps.edgeMap[edge].type, saveAsStringMap, parameterEntityMaps)
                let tabHeader = myThis.maps.edgeMap[edge].type;
                //false edge properties yok true edge properties var
                let isEdgeIncluded = Object.keys(myThis.maps.edgeMap[edge].properties).length > 0 ? true : false;
                if (
                    myThis.tableTabs.map(function (e) {
                        return e.value;
                    }).indexOf(tabHeader) < 0 &&
                    !tabHeader.includes(constant.CUSTOM_NODE_ENTITY_NAME) && !tabHeader.includes(constant.GROUP_EDGE_ENTITY_NAME)
                    && !tabHeader.includes(constant.CUSTOM_GROUP_NODE_ENTITY_NAME)
                ) {
                    if (myThis.maps.edgeMap[edge].type != constant.CUSTOM_EDGE_ENTITY_NAME &&
                        myThis.maps.edgeMap[edge].type != constant.GROUP_EDGE_ENTITY_NAME) {
                        let tabText = myThis.entityAliasMap[tabHeader] ? myThis.entityAliasMap[tabHeader] : tabHeader;
                        myThis.tableTabs.push({ text: tabText, index: tabIndex, value: tabHeader, isEdgeTab: true });
                        tabIndex++;
                        this.prepareTableHeaders(myThis, myThis.maps.edgeMap[edge], isEdgeIncluded, tabHeader);
                    }
                }
                if (!tabHeader.includes(constant.CUSTOM_NODE_ENTITY_NAME) && !tabHeader.includes(constant.CUSTOM_GROUP_NODE_ENTITY_NAME) &&
                    myThis.maps.edgeMap[edge].type != constant.CUSTOM_EDGE_ENTITY_NAME && !tabHeader.includes(constant.GROUP_EDGE_ENTITY_NAME) &&
                    myThis.maps.edgeMap[edge].type != constant.GROUP_EDGE_ENTITY_NAME) {
                    this.createTableData(myThis, myThis.maps.edgeMap[edge], isEdgeIncluded, tabHeader, parameterEntityMaps);
                }
            });
            if (queryFrom != "globalQuery") {
                this.addNodesWithoutEdgesToTable(tabIndex, myThis);
            }
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    createTableFromSingleQuery(myThis) {
        let helperThis = this;
        if (localStorage.saveAsStringMap && localStorage.parameterEntityMaps) {
            const saveAsStringMap = JSON.parse(localStorage.saveAsStringMap);
            const parameterEntityMaps = commonFunc.getCompressedItem('parameterEntityMaps');
            let tabHeadersList = [];
            let tabIndex = 0;
            const entityTypeList = [];
            myThis.singleQueryData.forEach(data => {
                if (tabHeadersList.indexOf(data.type) == -1) {
                    tabHeadersList.push(data.type);
                    entityTypeList.push(data.type);
                }
            });

            tabHeadersList.forEach(tabHeader => {
                let tabText = myThis.entityAliasMap[tabHeader] ? myThis.entityAliasMap[tabHeader] : tabHeader;
                myThis.tableTabs.push({ text: tabText, index: tabIndex, value: tabHeader, isEdgeTab: false });

                tabIndex++;
                let headers = [];
                if (myThis.subEntitiesMap && myThis.subEntitiesMap[tabHeader]) {
                    headers = helperThis.prepareSubEntityHeaders(tabHeader, headers, myThis);
                } else {
                    headers = helperThis.prepareSortedHeaders(tabHeader, headers, false, tabHeader, "singleQuery", myThis);
                }
                const firstMatchingData = myThis.singleQueryData.find(data => data.type === tabHeader);
                if (firstMatchingData) {
                    helperThis.addDynamicRepeatCountHeader(headers, firstMatchingData.properties, false, tabHeader);
                }

                myThis.multiTableData[tabHeader] = {
                    headers: headers,
                    items: [],
                    selected: [],
                };
                myThis.itemKey = myThis.singleQueryData[0].uniqueField;
                myThis.singleQueryData.forEach(data => {
                    if (data.type == tabHeader) {
                        this.changeNumericParameterToString(data.properties, data.type, saveAsStringMap, parameterEntityMaps)
                        data.properties.id = data.uniqueField ? data.properties[data.uniqueField] : data.type + "_" + data.id;
                        data.properties.counter = myThis.itemCounter++;
                        data.properties.entityType = data.type;
                        myThis.multiTableData[tabHeader].items.push(data.properties);
                    }
                });
                myThis.multiTableData[tabHeader].entityList = entityTypeList;
                myThis.multiTableData[tabHeader].auditId = myThis.tableData?.data?.auditId ?? null;
            });
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    prepareTableHeaders(myThis, edge, isEdgePropsIncluded, tabHeader) {
        let sourceEntity = myThis.maps.nodeMap[edge.source];
        let targetEntity = myThis.maps.nodeMap[edge.target];

        let headers = [];
        if (sourceEntity.type !== targetEntity.type) {
            sourceEntity.entityAlias = sourceEntity.type;
            targetEntity.entityAlias = targetEntity.type;
        } else {
            sourceEntity.entityAlias = sourceEntity.type + "_1";
            targetEntity.entityAlias = targetEntity.type + "_2";
        }
        let nodeEdgeMapName = sourceEntity.entityAlias + "_" + edge.type + "_" + targetEntity.entityAlias;
        if (myThis.nodeEdgeMappingHeaders[nodeEdgeMapName]) {
            this.prepareSortedNodeEdgeMapTableHeaders(nodeEdgeMapName, headers, myThis);
        } else {
            this.prepareSortedHeaders(sourceEntity.type, headers, true, sourceEntity.entityAlias, "complexQuery", myThis);
            if (isEdgePropsIncluded) {
                this.prepareSortedHeaders(edge.type, headers, true, edge.type, "complexQuery", myThis);
            }
            this.prepareSortedHeaders(targetEntity.type, headers, true, targetEntity.entityAlias, "complexQuery", myThis);
        }
        this.addDynamicRepeatCountHeader(headers, sourceEntity.properties, true, sourceEntity.entityAlias);
        if (isEdgePropsIncluded) {
            this.addDynamicRepeatCountHeader(headers, edge.properties, true, edge.type);
        }
        this.addDynamicRepeatCountHeader(headers, targetEntity.properties, true, targetEntity.entityAlias);
        if (!tabHeader.includes(constant.CUSTOM_NODE_ENTITY_NAME) && !tabHeader.includes(constant.GROUP_EDGE_ENTITY_NAME) &&
            !tabHeader.includes(constant.CUSTOM_GROUP_NODE_ENTITY_NAME)) {

            const entityList = [];
            entityList.push(sourceEntity.type);
            if (isEdgePropsIncluded) {
                entityList.push(edge.type);
            }
            entityList.push(targetEntity.type);

            myThis.multiTableData[tabHeader] = {
                headers: headers,
                items: [],
                selected: [],
                entityList: entityList,
                auditId: myThis.tableData?.data?.auditId ?? null
            };
        }
    },
    prepareSortedNodeEdgeMapTableHeaders(nodeEdgeMapName, headers, myThis) {
        Object.keys(myThis.nodeEdgeMappingHeaders[nodeEdgeMapName])
            .sort(function (a, b) {
                return (
                    myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][a].tableOrder -
                    myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][b].tableOrder
                );
            })
            .forEach(function (key) {
                if (myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][key].tableVisibility) {
                    const header = {
                        text: myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][key].alias
                            ? myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][key].alias
                            : key,
                        align: "start",
                        value: key,
                        datatype: myThis.nodeEdgeMappingHeaders[nodeEdgeMapName][key].dataType
                    };
                    const keyParts = key.split('_');
                    if (myThis.visibleHeaders[keyParts[0]][keyParts[1]] && myThis.visibleHeaders[keyParts[0]][keyParts[1]].columnWidth) {
                        header.width = myThis.visibleHeaders[keyParts[0]][keyParts[1]].columnWidth
                    }
                    headers.push(header);
                }
            });
    },
    createTableData(myThis, edgeEntity, isEdgePropsIncluded, tabHeader, parameterEntityMaps) {
        if (localStorage.saveAsStringMap && localStorage.parameterEntityMaps) {
            const saveAsStringMap = JSON.parse(localStorage.saveAsStringMap);
            let sourceEntity = myThis.maps.nodeMap[edgeEntity.source];
            let targetEntity = myThis.maps.nodeMap[edgeEntity.target];
            if (sourceEntity.type !== targetEntity.type) {
                sourceEntity.entityAlias = sourceEntity.type;
                targetEntity.entityAlias = targetEntity.type;
            } else {
                sourceEntity.entityAlias = sourceEntity.type + "_1";
                targetEntity.entityAlias = targetEntity.type + "_2";
            }
            let allItems = {};

            if (Object.keys(edgeEntity.properties).length > 0) {
                allItems = {};
                allItems["id"] = edgeEntity.id;
                allItems["counter"] = myThis.itemCounter++;
                Object.keys(sourceEntity.properties).forEach(prop => {
                    allItems[sourceEntity.entityAlias + "_" + prop] = sourceEntity.properties[prop];
                });

                if (isEdgePropsIncluded) {
                    Object.keys(edgeEntity.properties).forEach(prop => {
                        allItems[edgeEntity.type + "_" + prop] = edgeEntity.properties[prop];
                    });
                }
                Object.keys(targetEntity.properties).forEach(prop => {
                    this.changeNumericParameterToString(targetEntity.properties, targetEntity.type, saveAsStringMap, parameterEntityMaps)
                    allItems[targetEntity.entityAlias + "_" + prop] = targetEntity.properties[prop];
                });
                myThis.multiTableData[tabHeader].items.push(allItems);
                if (myThis.tableData && myThis.tableData.changes && myThis.tableData.changes.edgeMap[edgeEntity.id]) {
                    myThis.notificationSelectMap[edgeEntity.id] = true;
                }
            } else {
                allItems["id"] = edgeEntity.id;
                allItems["counter"] = myThis.itemCounter++;
                Object.keys(sourceEntity.properties).forEach(prop => {
                    allItems[sourceEntity.entityAlias + "_" + prop] = sourceEntity.properties[prop];
                });
                Object.keys(targetEntity.properties).forEach(prop => {
                    allItems[targetEntity.entityAlias + "_" + prop] = targetEntity.properties[prop];
                });
                if (myThis.multiTableData[tabHeader]) {
                    myThis.multiTableData[tabHeader].items.push(allItems);
                    if (myThis.tableData && myThis.tableData.changes && myThis.tableData.changes.edgeMap[edgeEntity.id]) {
                        myThis.notificationSelectMap[edgeEntity.id] = true;
                    }
                }
            }
        }
        else {
            this.errorHandler("metaDataLoadError");
        }
    },
    addNodesWithoutEdgesToTable(tabIndex, myThis) {
        if (localStorage.saveAsStringMap && localStorage.parameterEntityMaps) {
            const saveAsStringMap = JSON.parse(localStorage.saveAsStringMap);
            const parameterEntityMaps = commonFunc.getCompressedItem('parameterEntityMaps');
            if (Object.keys(myThis.maps.nodeMap).length > 0) {
                Object.keys(myThis.maps.nodeMap).forEach(node => {
                    if (Object.keys(myThis.maps.nodeMap[node].properties).length > 0) {
                        let tabHeader = myThis.maps.nodeMap[node].type;
                        this.changeNumericParameterToString(myThis.maps.nodeMap[node].properties, myThis.maps.nodeMap[node].type, saveAsStringMap, parameterEntityMaps)

                        // tanımlı olmayan node type gelirse liste ekranında gösterilmemesi için
                        if (myThis.visibleHeaders[tabHeader]) {
                            if (
                                myThis.tableTabs.map(function (e) {
                                    return e.value;
                                }).indexOf(tabHeader) < 0
                            ) {
                                let tabText = myThis.entityAliasMap[tabHeader] ? myThis.entityAliasMap[tabHeader] : tabHeader;
                                myThis.tableTabs.push({ text: tabText, index: tabIndex, value: tabHeader, isEdgeTab: false });
                                tabIndex++;
                                let headers = [];
                                headers = this.prepareSortedHeaders(
                                    myThis.maps.nodeMap[node].type,
                                    headers,
                                    false,
                                    myThis.maps.nodeMap[node].type,
                                    "singleQuery", myThis
                                );
                                this.addDynamicRepeatCountHeader(
                                    headers,
                                    myThis.maps.nodeMap[node].properties,
                                    false,
                                    myThis.maps.nodeMap[node].type
                                );

                                let aliasHeader = {
                                    text: commonFunc.localize("Etiket"),
                                    align: "start",
                                    value: "alias",
                                    datatype: "String"
                                }
                                headers.push(aliasHeader);

                                myThis.multiTableData[tabHeader] = {
                                    headers: headers,
                                    items: [],
                                    selected: [],
                                    entityList: [myThis.maps.nodeMap[node].type],
                                    auditId: myThis.tableData?.data?.auditId ?? null
                                };
                            }

                            let allItems = {};
                            allItems.id = myThis.maps.nodeMap[node].id;
                            allItems.key = node;
                            allItems.entityType = myThis.maps.nodeMap[node].type;
                            Object.keys(myThis.maps.nodeMap[node].properties).forEach(prop => {
                                allItems[prop] = myThis.maps.nodeMap[node].properties[prop];
                                allItems["counter"] = myThis.itemCounter++;
                                let entityAliasArray = [];
                                if (myThis.maps.nodeMap[node].alias && Object.keys(myThis.maps.nodeMap[node].alias).length > 0) {
                                    Object.keys(myThis.maps.nodeMap[node].alias).forEach(entityAlias => {
                                        let entityAliasText = "";
                                        if (myThis.entityAliasMap[myThis.maps.nodeMap[node].type]) {
                                            // Because of the db language we used us-EN for uppercase
                                            let count = entityAlias.split(myThis.maps.nodeMap[node].type.toUpperCase("us-EN"))[1];
                                            entityAliasText = myThis.entityAliasMap[myThis.maps.nodeMap[node].type] + (count ? count : '');
                                        } else {
                                            entityAliasText = entityAlias;
                                        }

                                        entityAliasArray.push(entityAliasText);
                                    });
                                }

                                allItems["alias"] = entityAliasArray.length > 0 ? entityAliasArray.join(',') : "";
                            });
                            myThis.multiTableData[tabHeader].items.push(allItems);
                            if (myThis.tableData && myThis.tableData.changes && myThis.tableData.changes.nodeMap[node]) {
                                myThis.notificationSelectMap[allItems.id] = true;
                            }
                        }
                    }
                });
            }
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    createGraphDataWithSelectedEdges(myThis, selectedMapElements, filteredMaps) {
        if (myThis.tableData && myThis.tableData.from === "singleQuery") {
            return;
        }
        myThis.dataWithoutSubEntities = {
            nodeMap: {},
            edgeMap: {},
            subEdgeMap: {},
            subNodeMap: {},
            notDrawedEdgesMap: {}

        };
        let allMaps = filteredMaps ? filteredMaps : myThis.maps;
        let mergeWithSubEntities = true;

        if (myThis.analysisMode == "allQuery" && !selectedMapElements) {
            myThis.dataWithoutSubEntities.edgeMap = JSON.parse(JSON.stringify(allMaps.edgeMap));
            myThis.dataWithoutSubEntities.nodeMap = JSON.parse(JSON.stringify(allMaps.nodeMap));
            myThis.dataWithoutSubEntities.subNodeMap = JSON.parse(JSON.stringify(allMaps.subNodeMap));
            myThis.dataWithoutSubEntities.subEdgeMap = JSON.parse(JSON.stringify(allMaps.subEdgeMap));
            myThis.dataWithoutSubEntities.notDrawedEdgesMap = JSON.parse(JSON.stringify(allMaps.notDrawedEdgesMap));
            myThis.selected = [];
        } else if (selectedMapElements) {
            if (myThis.analysisMode == "allQuery") {
                myThis.dataWithoutSubEntities.nodeMap = JSON.parse(JSON.stringify(selectedMapElements.nodeMap));
            } else {
                myThis.dataWithoutSubEntities.edgeMap = JSON.parse(JSON.stringify(selectedMapElements.edgeMap));
                myThis.dataWithoutSubEntities.subEdgeMap = JSON.parse(JSON.stringify(selectedMapElements.subEdgeMap));
                myThis.dataWithoutSubEntities.nodeMap = JSON.parse(JSON.stringify(selectedMapElements.nodeMap));
                myThis.dataWithoutSubEntities.subNodeMap = JSON.parse(JSON.stringify(selectedMapElements.subNodeMap));
                myThis.dataWithoutSubEntities.notDrawedEdgesMap = JSON.parse(JSON.stringify(selectedMapElements.notDrawedEdgesMap));

            }


            myThis.selected = [];
        } else if (myThis.analysisMode == "selectedItemsForGroup") {
            this.groupEdgesWithFilters(myThis, allMaps);
            mergeWithSubEntities = false;
        } else {
            let findDegreeNode = {};

            myThis.selected.forEach(selectedEntity => {
                if (selectedEntity.id && selectedEntity.id.toString().indexOf("_") != -1) {
                    //edge
                    let selectedEdgeId = selectedEntity.id;
                    if (allMaps.edgeMap[selectedEdgeId]) {
                        myThis.dataWithoutSubEntities.edgeMap[selectedEdgeId] = allMaps.edgeMap[selectedEdgeId];
                        myThis.dataWithoutSubEntities.subEdgeMap[selectedEdgeId] = allMaps.subEdgeMap[selectedEdgeId];
                        myThis.dataWithoutSubEntities.subNodeMap[selectedEdgeId] = allMaps.subNodeMap[selectedEdgeId];
                        myThis.dataWithoutSubEntities.notDrawedEdgesMap[selectedEdgeId] = allMaps.notDrawedEdgesMap[selectedEdgeId];

                        //source
                        if (
                            allMaps.nodeMap[allMaps.edgeMap[selectedEdgeId].source] &&
                            !myThis.dataWithoutSubEntities.nodeMap[allMaps.edgeMap[selectedEdgeId].source]
                        ) {
                            // edge ait source nodeun hem source hem target olduğu 1. derece ilişkileri bulunmakta
                            findDegreeNode[allMaps.edgeMap[selectedEdgeId].source] = true;
                            myThis.dataWithoutSubEntities.nodeMap[allMaps.edgeMap[selectedEdgeId].source] = JSON.parse(
                                JSON.stringify(allMaps.nodeMap[allMaps.edgeMap[selectedEdgeId].source])
                            );
                        }

                        // target
                        if (
                            allMaps.nodeMap[allMaps.edgeMap[selectedEdgeId].target] &&
                            !myThis.dataWithoutSubEntities.nodeMap[allMaps.edgeMap[selectedEdgeId].target]
                        ) {
                            myThis.dataWithoutSubEntities.nodeMap[allMaps.edgeMap[selectedEdgeId].target] = JSON.parse(
                                JSON.stringify(allMaps.nodeMap[allMaps.edgeMap[selectedEdgeId].target])
                            );
                        }
                    }
                } else {
                    //node
                    let selectedNodeId = selectedEntity.key;
                    if (allMaps.nodeMap[selectedNodeId] && !myThis.dataWithoutSubEntities.nodeMap[selectedNodeId]) {
                        findDegreeNode[selectedNodeId] = true;
                        myThis.dataWithoutSubEntities.nodeMap[selectedNodeId] = JSON.parse(JSON.stringify(allMaps.nodeMap[selectedNodeId]));
                    }
                }
            });

            // findFirstDegreeEdge
            if (myThis.analysisMode == "selectedItemsWithFirstDegree") {
                Object.keys(allMaps.edgeMap).forEach(edge => {
                    let findNodeId = null;
                    if (findDegreeNode[allMaps.edgeMap[edge].source]) {
                        findNodeId = allMaps.edgeMap[edge].target;
                    } else if (findDegreeNode[allMaps.edgeMap[edge].target]) {
                        findNodeId = allMaps.edgeMap[edge].source;
                    }

                    if (findNodeId) {
                        myThis.dataWithoutSubEntities.edgeMap[edge] = allMaps.edgeMap[edge];

                        if (!myThis.dataWithoutSubEntities.nodeMap[allMaps.nodeMap[findNodeId].id]) {
                            myThis.dataWithoutSubEntities.nodeMap[findNodeId] = JSON.parse(
                                JSON.stringify(allMaps.nodeMap[findNodeId])
                            );
                        }

                        if (!selectedMapElements) {
                            myThis.dataWithoutSubEntities.subEdgeMap[edge] = allMaps.subEdgeMap[edge]
                            myThis.dataWithoutSubEntities.subNodeMap[edge] = allMaps.subNodeMap[edge]
                            myThis.dataWithoutSubEntities.notDrawedEdgesMap[edge] = allMaps.notDrawedEdgesMap[edge];
                        }
                    }
                });
            }
        }
        if (mergeWithSubEntities) {
            this.createGraphDataWithSubEntities(myThis, allMaps);
        }
    },
    createGraphDataWithSubEntities(myThis, allMaps) {
        if (localStorage.saveAsStringMap && localStorage.parameterEntityMaps && localStorage.entitiesWithAttributes) {
            myThis.saveAsStringMap = JSON.parse(localStorage.saveAsStringMap);
            myThis.parameterEntityMaps = commonFunc.getCompressedItem('parameterEntityMaps');
            myThis.entitiesWithAttributes = commonFunc.getCompressedItem('entitiesWithAttributes');
        }

        myThis.graphData = {
            nodeMap: {},
            edgeMap: {}
        };
        myThis.graphData.nodeMap = JSON.parse(JSON.stringify(myThis.dataWithoutSubEntities.nodeMap));
        myThis.graphData.edgeMap = JSON.parse(JSON.stringify(myThis.dataWithoutSubEntities.edgeMap));
        if (allMaps) {
            Object.keys(allMaps.subEdgeMap).forEach(edge => {
                if (myThis.graphData.edgeMap[edge]) {
                    myThis.graphData.edgeMap = {
                        ...myThis.graphData.edgeMap,
                        ...allMaps.subEdgeMap[edge]
                    };
                }
            });

            Object.keys(allMaps.subNodeMap).forEach(edge => {
                if (myThis.graphData.edgeMap[edge]) {
                    const entityName = myThis.graphData.edgeMap[edge].label;
                    this.convertSubNodeValuesToText(myThis, entityName, allMaps.subNodeMap[edge]);
                    myThis.graphData.nodeMap = {
                        ...myThis.graphData.nodeMap,
                        ...allMaps.subNodeMap[edge]
                    };
                }
            });

            Object.keys(allMaps.notDrawedEdgesMap).forEach(edge => {
                delete myThis.graphData.edgeMap[edge];
            });
        }

    },
    convertSubNodeValuesToText(myThis, entityName, subNodes) {
        if (entityName && myThis.saveAsStringMap && myThis.saveAsStringMap[entityName]) {
            Object.keys(subNodes).forEach(nodeKey => {
                const node = subNodes[nodeKey];
                if (node.properties) {
                    Object.keys(node.properties).forEach(propKey => {
                        if (myThis.saveAsStringMap[entityName][propKey]) {
                            node.properties[propKey] = this.getParameterStringValue(
                                myThis,
                                entityName,
                                propKey,
                                node.properties[propKey]
                            );
                        }
                    });
                }
            });
        }
        return subNodes;
    },
    getParameterStringValue(myThis, entityName, attrName, value) {
        if (
            !value ||
            !myThis.saveAsStringMap ||
            !myThis.saveAsStringMap[entityName] ||
            !myThis.saveAsStringMap[entityName][attrName]
        ) {
            return value;
        }
        const paramConfig = myThis.saveAsStringMap[entityName][attrName];
        const parameterMap = myThis.parameterEntityMaps[paramConfig.fillEntityId];

        if (parameterMap) {
            const found = parameterMap.find((t) => t[paramConfig.valueEntityAttributeName] == value);
            if (found) {
                return found[paramConfig.textEntityAttributeName] || value;
            }
        }
        return value;
    },
    createGraphDatafromSingleQuery(myThis) {
        if (myThis.dataFrom != "globalQuery") {
            myThis.dataWithoutSubEntities = {
                nodeMap: {},
                edgeMap: {}
            };
            myThis.graphData.nodeMap = {};
        } else {
            //TODO: tolgaky: ilk önce complex query gönderdiysek sonrasında node gönderdiğimizde nodeMapleri temizlemek için. iyileştirilebilir
            if (Object.keys(myThis.graphData.edgeMap).length == 0) {
                myThis.graphData.nodeMap = {};
                myThis.dataWithoutSubEntities.nodeMap = {};
            }
        }

        myThis.tableData.from = "singleQuery";

        if (myThis.analysisMode == "allQuery") {
            myThis.selected = [];
            myThis.singleQueryData.forEach(data => {
                myThis.selected.push(data.properties);
            });
        }

        myThis.selected.forEach(node => {
            let selectedNode = myThis.singleQueryData.filter(nodeData => {
                return (
                    node["id"] == nodeData.properties["id"] &&
                    node[nodeData.uniqueField] == nodeData.properties[nodeData.uniqueField]
                );
            });
            if (selectedNode.length > 0) {
                myThis.dataWithoutSubEntities.nodeMap[
                    selectedNode[0].uniqueValue
                ] = {
                    properties: selectedNode[0].properties,
                    type: selectedNode[0].type,
                    id: selectedNode[0].uniqueValue.split('_')[1],
                    uniqueValue: selectedNode[0].uniqueValue
                };

                myThis.graphData.nodeMap[
                    selectedNode[0].uniqueValue
                ] = {
                    properties: selectedNode[0].properties,
                    type: selectedNode[0].type,
                    id: selectedNode[0].uniqueValue.split('_')[1],
                    uniqueValue: selectedNode[0].uniqueValue
                };
            }
        });

        if (myThis.analysisMode == "allQuery") {
            myThis.selected = [];
        }
    },
    prepareSubEntityHeaders(entity, headers, myThis) {

        if (myThis.singleQueryData && myThis.singleQueryData.length > 0) {
            let header = {};
            if (entity == constant.CUSTOM_SUB_NODE || entity == constant.CUSTOM_GROUP_SUB_NODE) {
                let dataProperties = myThis.singleQueryData[0].properties;
                Object.keys(dataProperties).forEach(prop => {
                    header = {
                        text: prop,
                        align: "start",
                        value: prop,
                        datatype: "String"
                    }
                    headers.push(header);
                })
            } else {
                myThis.singleQueryData[0].visibleProps.forEach(attr => {
                    header = {
                        text: attr,
                        align: "start",
                        value: attr,
                        datatype: "String"
                    };
                    headers.push(header);
                })
            }

        }
        return headers;
    },
    prepareSortedHeaders(entity, headers, isNodeTypeIncluded, alias, from, myThis) {
        if (myThis.visibleHeaders[entity]) {
            Object.keys(myThis.visibleHeaders[entity])
                .sort(function (a, b) {
                    return myThis.visibleHeaders[entity][a].tableOrder - myThis.visibleHeaders[entity][b].tableOrder;
                })
                .forEach(function (key) {
                    if (myThis.visibleHeaders[entity][key].tableVisibility) {
                        let header = {};
                        if (from == "singleQuery") {
                            let headerText =
                                myThis.visibleHeaders[entity][key].alias != null && myThis.visibleHeaders[entity][key].alias != ""
                                    ? myThis.visibleHeaders[entity][key].alias
                                    : alias + "_" + key;
                            if (isNodeTypeIncluded) {
                                header = {
                                    text: headerText,
                                    align: "start",
                                    value: alias + "_" + key,
                                    datatype: myThis.visibleHeaders[entity][key].dataType
                                };
                            } else {
                                header = {
                                    text: headerText,
                                    align: "start",
                                    value: key,
                                    datatype: myThis.visibleHeaders[entity][key].dataType
                                };
                            }
                        } else {
                            if (isNodeTypeIncluded) {
                                header = {
                                    text: alias + "_" + key,
                                    align: "start",
                                    value: alias + "_" + key,
                                    datatype: myThis.visibleHeaders[entity][key].dataType
                                };
                            } else {
                                header = {
                                    text: key,
                                    align: "start",
                                    value: key,
                                    datatype: myThis.visibleHeaders[entity][key].dataType
                                };
                            }
                        }
                        if (myThis.visibleHeaders[entity][key].columnWidth) {
                            header.width = myThis.visibleHeaders[entity][key].columnWidth;
                        }

                        headers.push(header);
                    }
                });
        }
        else {
            if (entity == "customNode" && myThis.singleQueryData && myThis.singleQueryData.length > 0) {
                myThis.singleQueryData.forEach(node => {
                    Object.keys(node.properties).forEach(prop => {
                        let header = {
                            text: prop,
                            align: "start",
                            value: prop,
                            datatype: "String"
                        }
                        headers.push(header);
                    })
                })

            }
        }

        return headers;
    },
    addDynamicRepeatCountHeader(headers, properties, isNodeTypeIncluded, alias) {
        const repeatCountKey = constant.filterCounterText;
        if (properties && properties.hasOwnProperty(repeatCountKey)) {
            const headerValue = isNodeTypeIncluded ? `${alias}_${repeatCountKey}` : repeatCountKey;
            const headerAlreadyExists = headers.some(h => h.value === headerValue);
            if (!headerAlreadyExists) {
                headers.push({
                    text: commonFunc.localize("recurrence.repeatCount"),
                    align: "start",
                    value: headerValue,
                    datatype: constant.ATTR_DATA_TYPES.Numeric
                });
            }
        }
    },
    mergeTwoMapObjectInside(firstObj, secondObj) {
        firstObj.nodeMap = { ...firstObj.nodeMap, ...secondObj.nodeMap };
        firstObj.edgeMap = { ...firstObj.edgeMap, ...secondObj.edgeMap };
        firstObj.subEdgeMap = { ...firstObj.subEdgeMap, ...secondObj.subEdgeMap };
        firstObj.subNodeMap = { ...firstObj.subNodeMap, ...secondObj.subNodeMap };
        firstObj.notDrawedEdgesMap = { ...firstObj.notDrawedEdgesMap, ...secondObj.notDrawedEdgesMap };
    },
    createGroupUniqueValue(myThis, row, nodeEdgeMapId) {
        let uniqueValueParts = [];
        let columnDataMap = {};
        uniqueValueParts.push(nodeEdgeMapId);
        myThis.selectedGroupValueMap[nodeEdgeMapId].forEach(columnName => {
            uniqueValueParts.push(row[columnName]);
            columnDataMap[columnName] = {
                value: row[columnName],
                isVisible: true
            };
        });
        return uniqueValueParts.join("");
    },
    prepareNumericAggr(row, prop, columnAggrMap, groupUniqueValue) {
        let replacedValue = row[prop.propName] ? commonFunc.replaceAllWithoutReplaceAll(row[prop.propName], ",", ".") : 0;
        let propValue = row[prop.propName] && !isNaN(replacedValue) ? parseFloat(replacedValue) : 0;
        if (prop.aggrType == "Sum") {
            columnAggrMap[groupUniqueValue][prop.propAlias].value += propValue;
        } else if (prop.aggrType == "Count") {
            columnAggrMap[groupUniqueValue][prop.propAlias].value++;
        } else if (prop.aggrType == "Max") {
            columnAggrMap[groupUniqueValue][prop.propAlias].value = columnAggrMap[groupUniqueValue][prop.propAlias].value > propValue ? columnAggrMap[groupUniqueValue][prop.propAlias].value : propValue
        } else if (prop.aggrType == "Min") {
            columnAggrMap[groupUniqueValue][prop.propAlias].value = columnAggrMap[groupUniqueValue][prop.propAlias].value < propValue ? columnAggrMap[groupUniqueValue][prop.propAlias].value : propValue
        } else if (prop.aggrType == "Avg") {
            if (!columnAggrMap[groupUniqueValue][prop.propAlias].count) {
                columnAggrMap[groupUniqueValue][prop.propAlias].count = 0;
            }
            columnAggrMap[groupUniqueValue][prop.propAlias].count++;
            columnAggrMap[groupUniqueValue][prop.propAlias].value += propValue;
        }
    },
    prepareDateAggr(row, prop, columnAggrMap, groupUniqueValue) {
        let currentDate = moment(columnAggrMap[groupUniqueValue][prop.propAlias].value, "DD.MM.YYYY");
        let rowDate = row[prop.propName] ? moment(row[prop.propName], "DD.MM.YYYY") : row[prop.propName];
        if (rowDate) {
            if (prop.aggrType == "Max") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value = currentDate > rowDate ? columnAggrMap[groupUniqueValue][prop.propAlias].value : row[prop.propName];
            } else if (prop.aggrType == "Min") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value = currentDate < rowDate ? columnAggrMap[groupUniqueValue][prop.propAlias].value : row[prop.propName];
            }
        }
    },
    prepareDatetimeAggr(row, prop, columnAggrMap, groupUniqueValue) {
        let currentDate = moment(columnAggrMap[groupUniqueValue][prop.propAlias].value, "DD.MM.YYYY hh:mm:ss");
        let rowDate = row[prop.propName] ? moment(row[prop.propName], "DD.MM.YYYY hh:mm:ss") : row[prop.propName];
        if (rowDate) {
            if (prop.aggrType == "Max") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value = currentDate > rowDate ? columnAggrMap[groupUniqueValue][prop.propAlias].value : row[prop.propName];
            } else if (prop.aggrType == "Min") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value = currentDate < rowDate ? columnAggrMap[groupUniqueValue][prop.propAlias].value : row[prop.propName];
            }
        }
    },
    prepareGroupAggrEmptyData(prop, columnAggrMap, groupUniqueValue) {
        if (prop.attrDataType == constant.ATTR_DATA_TYPES.Numeric || prop.attrDataType == constant.ATTR_DATA_TYPES.Currency) {
            if (prop.aggrType == "Min") {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: Number.MAX_SAFE_INTEGER,
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            } else {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: 0,
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            }
        } else if (prop.attrDataType == constant.ATTR_DATA_TYPES.Date) {
            if (prop.aggrType == "Min") {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: "01.01.2100",
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            } else if (prop.aggrType == "Max") {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: "01.01.1900",
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            } else {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: 0,
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            }

        } else if (prop.attrDataType == constant.ATTR_DATA_TYPES.Datetime) {
            if (prop.aggrType == "Min") {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: "01.01.2100 00:00:00",
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                }
            } else if (prop.aggrType == "Max") {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: "01.01.1900 00:00:00",
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                }
            } else {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: 0,
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: prop.aggrType
                };
            }
        } else if (prop.aggrType == "Count") {
            columnAggrMap[groupUniqueValue][prop.propAlias] = {
                value: 0,
                isVisible: prop.isVisible,
                dataType: prop.attrDataType,
                aggrType: prop.aggrType
            };
        } else {
            columnAggrMap[groupUniqueValue][prop.propAlias] = {
                value: "",
                isVisible: prop.isVisible,
                dataType: prop.attrDataType,
                aggrType: prop.aggrType
            };
        }
    },
    prepareGroupAggr(row, prop, columnAggrMap, groupUniqueValue) {
        if (!columnAggrMap[groupUniqueValue][prop.propAlias]) {
            this.prepareGroupAggrEmptyData(prop, columnAggrMap, groupUniqueValue);
        }
        if (prop.attrDataType == constant.ATTR_DATA_TYPES.Numeric || prop.attrDataType == constant.ATTR_DATA_TYPES.Currency) {
            this.prepareNumericAggr(row, prop, columnAggrMap, groupUniqueValue);
        } else if (prop.attrDataType == constant.ATTR_DATA_TYPES.Date) {
            if (prop.aggrType == "Count") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value++;
            } else {
                this.prepareDateAggr(row, prop, columnAggrMap, groupUniqueValue);
            }
        } else if (prop.attrDataType == constant.ATTR_DATA_TYPES.Datetime) {
            if (prop.aggrType == "Count") {
                columnAggrMap[groupUniqueValue][prop.propAlias].value++;
            } else {
                this.prepareDatetimeAggr(row, prop, columnAggrMap, groupUniqueValue);
            }
        } else if (prop.aggrType == "Count") {
            columnAggrMap[groupUniqueValue][prop.propAlias].value++;
        }
    },
    prepareGroupProps(row, props, columnAggrMap, groupUniqueValue) {
        let helperThis = this;
        if (!columnAggrMap[groupUniqueValue]) {
            columnAggrMap[groupUniqueValue] = {};
        }
        props.forEach(prop => {
            if (!prop.aggrType) {
                columnAggrMap[groupUniqueValue][prop.propAlias] = {
                    value: row[prop.propName],
                    isVisible: prop.isVisible,
                    dataType: prop.attrDataType,
                    aggrType: null
                };
            } else {
                helperThis.prepareGroupAggr(row, prop, columnAggrMap, groupUniqueValue)
            }
        });
    },
    findClickedNodeRelatedNEM(myThis, willBeGroupClickedNode, nodeEdgeMaps) {
        let clickedNodeGroupEdges = [];

        if (willBeGroupClickedNode.data) {    //clickedNode is node
            let clickedNodeType = willBeGroupClickedNode.data.type;
            myThis.groupEdgeList.forEach(groupEdge => {
                let nodeEdgeMap = nodeEdgeMaps.find(nem => nem.id == groupEdge.nodeEdgeMapId);
                if (nodeEdgeMap.sourceNodeEntityName == clickedNodeType &&
                    myThis.selectedBaseEntityAliasMap[groupEdge.nodeEdgeMapId] != clickedNodeType &&
                    myThis.selectedBaseEntityAliasMap[groupEdge.nodeEdgeMapId] != nodeEdgeMap.edgeEntityName) {
                    clickedNodeGroupEdges.push(groupEdge);
                }
            });
            return clickedNodeGroupEdges;
        } else {  //clickedNode is subNode
            let willBeGroupEntityType = willBeGroupClickedNode.type;
            myThis.groupEdgeList.forEach(groupEdge => {
                let nodeEdgeMap = nodeEdgeMaps.find(nem => nem.id == groupEdge.nodeEdgeMapId);
                if (nodeEdgeMap.edgeEntityName == willBeGroupEntityType) {
                    clickedNodeGroupEdges.push(groupEdge);
                }
            });
            return clickedNodeGroupEdges;
        }

    },
    groupEdgesWithFilters(myThis, allMaps, willBeGroupClickedNode) {
        let helperThis = this;
        let alreadyAddedEdgeKeyMap = {};
        if (localStorage.nodeEdgeMapping) {
            let nodeEdgeMaps = JSON.parse(localStorage.nodeEdgeMapping);
            let willBeGroupList;
            if (willBeGroupClickedNode) {
                willBeGroupList = helperThis.findClickedNodeRelatedNEM(myThis, willBeGroupClickedNode, nodeEdgeMaps);
            } else {
                willBeGroupList = myThis.groupEdgeList;
            }
            if (willBeGroupList.length > 0) {
                if (myThis.groupTableType) {
                    willBeGroupList = willBeGroupList.filter(groupEdge => groupEdge.edgeName == myThis.activeTabValue)
                }
                willBeGroupList.forEach(groupEdge => {
                    helperThis.createGroupNodes(myThis, groupEdge, allMaps, alreadyAddedEdgeKeyMap, willBeGroupClickedNode, nodeEdgeMaps);
                });
                if (!myThis.groupTableType) {
                    this.addNotGroupEdgesToData(myThis, allMaps, alreadyAddedEdgeKeyMap);
                }
                this.createGraphDataWithGroupNode(myThis, myThis.dataWithoutSubEntities, allMaps);
            }
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    createGroupNodes(myThis, groupEdge, allMaps, alreadyAddedEdgeKeyMap, willBeGroupClickedNode, nodeEdgeMaps) {
        let helperThis = this;
        let groupNodeEdgeMap = {};
        let columnAggrMap = {};
        let willBeGroupEntity = myThis.selectedBaseEntityAliasMap[groupEdge.nodeEdgeMapId];
        let selectedNodeEdgeMap = nodeEdgeMaps.find(nodeEdgeMap => nodeEdgeMap.id == groupEdge.nodeEdgeMapId);

        if (myThis.multiTableData[groupEdge.edgeName]) {
            let tableData = myThis.multiTableData[groupEdge.edgeName].items;

            // tabloda ilgili edge'in verisi
            tableData.forEach(row => {
                let selectedEdge = allMaps.edgeMap[row.id];
                if (!willBeGroupClickedNode || (willBeGroupClickedNode.data && selectedEdge.source == willBeGroupClickedNode.id) ||
                    (selectedEdge.source == willBeGroupClickedNode.source && selectedEdge.target == willBeGroupClickedNode.target)) {
                    let groupUniqueValue = helperThis.createGroupUniqueValue(myThis, row, groupEdge.nodeEdgeMapId);
                    if (!groupNodeEdgeMap[groupUniqueValue]) {
                        groupNodeEdgeMap[groupUniqueValue] = {
                            nodeMap: {},
                            edgeMap: {},
                            subEdgeMap: {},
                            subNodeMap: {},
                            notDrawedEdgesMap: {},
                            sourceNodeKeyMap: {},
                            sourceKeyTargetKeyMap: {},
                        }
                    }
                    helperThis.prepareGroupProps(row, groupEdge.props, columnAggrMap, groupUniqueValue);

                    if (selectedNodeEdgeMap.sourceNodeEntityId == selectedNodeEdgeMap.targetEntityId && selectedNodeEdgeMap.edgeEntityName != willBeGroupEntity) {
                        let nodeCounter = willBeGroupEntity.split('_')[1];
                        if (nodeCounter == 1) {
                            groupNodeEdgeMap[groupUniqueValue].sourceNodeKeyMap[selectedEdge.target] = true;
                        } else {
                            groupNodeEdgeMap[groupUniqueValue].sourceNodeKeyMap[selectedEdge.source] = true;
                        }
                    }
                    else if (selectedEdge.source.split('_')[0] == willBeGroupEntity) {
                        groupNodeEdgeMap[groupUniqueValue].sourceNodeKeyMap[selectedEdge.target] = true;
                    } else if (selectedEdge.target.split('_')[0] == willBeGroupEntity) {
                        groupNodeEdgeMap[groupUniqueValue].sourceNodeKeyMap[selectedEdge.source] = true;
                    } else {
                        groupNodeEdgeMap[groupUniqueValue].sourceKeyTargetKeyMap[selectedEdge.source] = selectedEdge.target;
                    }

                    groupNodeEdgeMap[groupUniqueValue].nodeMap[selectedEdge.source] = allMaps.nodeMap[selectedEdge.source];
                    groupNodeEdgeMap[groupUniqueValue].nodeMap[selectedEdge.target] = allMaps.nodeMap[selectedEdge.target];
                    groupNodeEdgeMap[groupUniqueValue].edgeMap[selectedEdge.uniqueValue] = allMaps.edgeMap[selectedEdge.uniqueValue];
                    groupNodeEdgeMap[groupUniqueValue].subEdgeMap[selectedEdge.uniqueValue] = allMaps.subEdgeMap[selectedEdge.uniqueValue];
                    groupNodeEdgeMap[groupUniqueValue].subNodeMap[selectedEdge.uniqueValue] = allMaps.subNodeMap[selectedEdge.uniqueValue];
                    groupNodeEdgeMap[groupUniqueValue].notDrawedEdgesMap[selectedEdge.uniqueValue] = allMaps.notDrawedEdgesMap[selectedEdge.uniqueValue];
                    alreadyAddedEdgeKeyMap[selectedEdge.uniqueValue] = true;
                }
            });
            let groupEdgeElements;
            if (groupEdge.edgeName == willBeGroupEntity) {
                groupEdgeElements = helperThis.createGroupSubElements(myThis, groupNodeEdgeMap, allMaps, groupEdge, columnAggrMap);
            } else {
                groupEdgeElements = helperThis.createGroupEdgeElements(myThis, groupNodeEdgeMap, allMaps, groupEdge, columnAggrMap);
            }
            helperThis.mergeTwoMapObjectInside(myThis.dataWithoutSubEntities, groupEdgeElements)
        }

    },
    addNotGroupEdgesToData(myThis, allMaps, alreadyAddedEdgeKeyMap) {
        Object.keys(allMaps.edgeMap).forEach(edgeKey => {
            let selectedEdge = allMaps.edgeMap[edgeKey];
            if (!alreadyAddedEdgeKeyMap[edgeKey] && selectedEdge.type != "GroupEdge") {
                myThis.dataWithoutSubEntities.edgeMap[edgeKey] = selectedEdge;
                myThis.dataWithoutSubEntities.nodeMap[selectedEdge.source] = allMaps.nodeMap[selectedEdge.source];
                myThis.dataWithoutSubEntities.nodeMap[selectedEdge.target] = allMaps.nodeMap[selectedEdge.target];
                if (allMaps.subNodeMap[edgeKey]) {
                    myThis.dataWithoutSubEntities.subEdgeMap[edgeKey] = allMaps.subEdgeMap[edgeKey];
                    myThis.dataWithoutSubEntities.subNodeMap[edgeKey] = allMaps.subNodeMap[edgeKey];
                    myThis.dataWithoutSubEntities.notDrawedEdgesMap[edgeKey] = allMaps.notDrawedEdgesMap[edgeKey];
                }

            }
        });
    },
    createGroupEdgeSubNode(currentNodeEdgeMap, groupSubNodeKey, groupNodeId, groupNodeDetails, groupSubNodeProps) {
        let avgProps = [], currencyTypeProps = [], visibleProps = [];
        Object.values(groupSubNodeProps).forEach(prop => {
            if (prop.count) {
                avgProps.push(prop);
            }
            if (prop.dataType == constant.ATTR_DATA_TYPES.Currency && prop.aggrType != "Count") {
                currencyTypeProps.push(prop);
            }
            if (prop.isVisible) {
                visibleProps.push(prop);
            }
        })
        avgProps.forEach(prop => {
            prop.value = prop.value / prop.count
        });
        currencyTypeProps.forEach(prop => {
            if (prop.value && typeof prop.value != 'number') {
                prop.value = (parseInt(prop.value)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            } else {
                prop.value = (prop.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        });
        return {
            entityAlias: constant.GROUP_SUB_NODE_ENTITY_ALIAS,
            alias: groupNodeDetails.groupName,
            id: groupNodeId,
            label: groupNodeDetails.groupName,
            properties: groupSubNodeProps,
            type: constant.CUSTOM_GROUP_SUB_NODE,
            uniqueValue: groupSubNodeKey,
            visibleProps: visibleProps,
            groupElements: currentNodeEdgeMap
        };
    },
    createGroupSubEdges(resultMap, edgeId, sourceNodeKey, groupSubNodeKey, targetNodeKey, sourceNodeId, groupNodeId, targetNodeId, mainEdge, groupSubNode) {
        resultMap.subNodeMap[edgeId] = {};
        resultMap.subEdgeMap[edgeId] = {};
        resultMap.notDrawedEdgesMap[edgeId] = true;
        resultMap.subNodeMap[edgeId][groupSubNodeKey] = groupSubNode;
        let tempFirstSubEdgeId = sourceNodeId + "_" + groupNodeId + "_" + constant.CUSTOM_GROUP_SUB_NODE;
        let tempFirstSubEdgeUniqueValue = commonFunc.prepareUniqueValueForLink(tempFirstSubEdgeId);
        resultMap.subEdgeMap[edgeId][tempFirstSubEdgeId] = {
            id: tempFirstSubEdgeId,
            label: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            parentEdgeId: edgeId,
            properties: {},
            source: sourceNodeKey,
            target: groupSubNodeKey,
            type: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            uniqueValue: tempFirstSubEdgeUniqueValue,
        }

        let tempSecondSubEdgeId = groupNodeId + "_" + targetNodeId + "_" + constant.CUSTOM_GROUP_SUB_NODE;
        let tempSecondSubEdgeUniqueValue = commonFunc.prepareUniqueValueForLink(tempSecondSubEdgeId);
        resultMap.subEdgeMap[edgeId][tempSecondSubEdgeId] = {
            id: tempSecondSubEdgeId,
            label: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            parentEdgeId: edgeId,
            properties: {},
            source: groupSubNodeKey,
            target: targetNodeKey,
            type: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            uniqueValue: tempSecondSubEdgeUniqueValue,
            groupEdgeColor: mainEdge.entityColor,
            groupEdgeThickness: mainEdge.entityThick
        }
    },
    createGroupSubElements(myThis, groupNodeEdgeMap, allMaps, groupEdge, columnAggrMap) {
        let helperThis = this;
        let resultMap = this.createEmptyNodeEdgeMap();

        Object.keys(groupNodeEdgeMap).forEach(groupNodeId => {
            let groupSubNodeKey = constant.CUSTOM_GROUP_SUB_NODE + "_" + groupNodeId;
            let groupSubNode = helperThis.createGroupEdgeSubNode(groupNodeEdgeMap[groupNodeId], groupSubNodeKey, groupNodeId, groupEdge, columnAggrMap[groupNodeId]);
            let mainEdgeType = groupNodeEdgeMap[groupNodeId].edgeMap[Object.keys(groupNodeEdgeMap[groupNodeId].edgeMap)[0]].type;
            let mainEdge = myThis.entitiesWithAttributes.find(entity => entity.name == mainEdgeType);
            let sourceKeyTargetKeyMap = groupNodeEdgeMap[groupNodeId].sourceKeyTargetKeyMap;
            Object.keys(sourceKeyTargetKeyMap).forEach(sourceNodeKey => {
                resultMap.nodeMap[sourceNodeKey] = allMaps.nodeMap[sourceNodeKey];
                resultMap.nodeMap[sourceKeyTargetKeyMap[sourceNodeKey]] = allMaps.nodeMap[sourceKeyTargetKeyMap[sourceNodeKey]];
                let sourceNodeId = sourceNodeKey.split('_')[1];
                let targetNodeId = sourceKeyTargetKeyMap[sourceNodeKey].split("_")[1];
                let edgeId = sourceNodeId + '_' + targetNodeId + '_' + constant.GROUP_EDGE_ENTITY_NAME;
                resultMap.edgeMap[edgeId] = {
                    id: edgeId,
                    label: constant.GROUP_EDGE_ENTITY_ALIAS,
                    parentEdgeId: null,
                    properties: {},
                    source: sourceNodeKey,
                    target: sourceKeyTargetKeyMap[sourceNodeKey],
                    type: constant.GROUP_EDGE_ENTITY_NAME,
                    uniqueValue: edgeId,
                    groupEdgeColor: mainEdge.entityColor,
                    groupEdgeThickness: mainEdge.entityThick
                };

                helperThis.createGroupSubEdges(resultMap, edgeId, sourceNodeKey, groupSubNodeKey, sourceKeyTargetKeyMap[sourceNodeKey],
                    sourceNodeId, groupNodeId, targetNodeId, mainEdge, groupSubNode);
            });
        })
        return resultMap;

    },
    createGroupEdgeElements(myThis, groupNodeEdgeMap, allMaps, groupEdge, columnAggrMap) {
        let helperThis = this;
        let resultMap = this.createEmptyNodeEdgeMap();

        Object.keys(groupNodeEdgeMap).forEach(groupNodeId => {
            let groupNodeKey = constant.CUSTOM_GROUP_NODE_ENTITY_NAME + "_" + groupNodeId;
            let groupNode = helperThis.createGroupNode(groupNodeEdgeMap[groupNodeId], groupNodeKey, groupNodeId, groupEdge, columnAggrMap[groupNodeId]);
            let mainEdgeType = groupNodeEdgeMap[groupNodeId].edgeMap[Object.keys(groupNodeEdgeMap[groupNodeId].edgeMap)[0]].type;
            let mainEdge = myThis.entitiesWithAttributes.find(entity => entity.name == mainEdgeType);
            resultMap.nodeMap[groupNodeKey] = groupNode;
            Object.keys(groupNodeEdgeMap[groupNodeId].sourceNodeKeyMap).forEach(sourceNodeKey => {
                resultMap.nodeMap[sourceNodeKey] = allMaps.nodeMap[sourceNodeKey];
                let sourceNodeId = sourceNodeKey.split('_')[1];
                let edgeId = sourceNodeId + '_' + groupNodeId + '_' + constant.GROUP_EDGE_ENTITY_NAME;
                resultMap.edgeMap[edgeId] = {
                    id: edgeId,
                    label: constant.GROUP_EDGE_ENTITY_ALIAS,
                    parentEdgeId: null,
                    properties: {},
                    source: sourceNodeKey,
                    target: groupNodeKey,
                    type: constant.GROUP_EDGE_ENTITY_NAME,
                    uniqueValue: edgeId,
                    groupEdgeColor: mainEdge.entityColor,
                    groupEdgeThickness: mainEdge.entityThick
                };
                helperThis.createGroupSubNodes(resultMap, edgeId, sourceNodeKey, groupNodeKey, sourceNodeId, groupNodeId, groupEdge.groupName, mainEdge);
            });
        })
        return resultMap;
    },
    createGroupSubNodes(resultMap, edgeId, sourceNodeKey, groupNodeKey, sourceNodeId, groupNodeId, subNodeName, mainEdge) {
        let tempSourceNodeId = sourceNodeId;
        let tempSourceNodeKey = sourceNodeKey;
        resultMap.subNodeMap[edgeId] = {};
        resultMap.subEdgeMap[edgeId] = {};
        resultMap.notDrawedEdgesMap[edgeId] = true;
        let tempSubNodeId = sourceNodeId + groupNodeId;
        let tempSubNodeNodeKey = commonFunc.prepareUniqueValueForNode(constant.CUSTOM_GROUP_SUB_NODE, tempSubNodeId)
        resultMap.subNodeMap[edgeId][tempSubNodeNodeKey] = {
            alias: subNodeName,
            id: tempSubNodeId,
            label: subNodeName,
            properties: {
                "Adı": {
                    value: subNodeName,
                    isVisible: true,
                }
            },
            type: constant.CUSTOM_GROUP_SUB_NODE,
            uniqueValue: tempSubNodeNodeKey,
            visibleProps: ["Adı"],
        }
        let tempFirstSubEdgeId = tempSourceNodeId + "_" + tempSubNodeId + "_" + constant.CUSTOM_GROUP_SUB_NODE;
        let tempFirstSubEdgeUniqueValue = commonFunc.prepareUniqueValueForLink(tempFirstSubEdgeId);
        resultMap.subEdgeMap[edgeId][tempFirstSubEdgeId] = {
            id: tempFirstSubEdgeId,
            label: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            parentEdgeId: edgeId,
            properties: {},
            source: tempSourceNodeKey,
            target: tempSubNodeNodeKey,
            type: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            uniqueValue: tempFirstSubEdgeUniqueValue,
        }

        let tempSecondSubEdgeId = tempSubNodeId + "_" + groupNodeId + "_" + constant.CUSTOM_GROUP_SUB_NODE;
        let tempSecondSubEdgeUniqueValue = commonFunc.prepareUniqueValueForLink(tempSecondSubEdgeId);
        resultMap.subEdgeMap[edgeId][tempSecondSubEdgeId] = {
            id: tempSecondSubEdgeId,
            label: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            parentEdgeId: edgeId,
            properties: {},
            source: tempSubNodeNodeKey,
            target: groupNodeKey,
            type: constant.GROUP_SUB_EDGE_ENTITY_NAME,
            uniqueValue: tempSecondSubEdgeUniqueValue,
            groupEdgeColor: mainEdge.entityColor,
            groupEdgeThickness: mainEdge.entityThick
        }
    },
    createGroupNode(currentNodeEdgeMap, groupNodeKey, groupNodeId, groupNodeDetails, groupNodeProps) {
        let avgProps = Object.values(groupNodeProps).filter(prop => prop.count);
        avgProps.forEach(prop => {
            prop.value = prop.value / prop.count
        });

        let currencyTypeProps = Object.values(groupNodeProps).filter(prop => prop.dataType == constant.ATTR_DATA_TYPES.Currency && prop.aggrType != "Count");
        currencyTypeProps.forEach(prop => {
            if (prop.value && typeof prop.value != 'number') {
                prop.value = (parseInt(prop.value)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            } else {
                prop.value = (prop.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        });
        return {
            alias: groupNodeDetails.groupName,
            entityAlias: constant.GROUP_NODE_ENTITY_ALIAS,
            id: groupNodeId,
            label: groupNodeDetails.groupName,
            properties: groupNodeProps,
            style: {
                icon: {
                    font: groupNodeDetails.iconPath,
                },
                shape: {
                    color: constant.GROUP_NODE_ENTITY_COLOR,
                },
            },
            type: constant.CUSTOM_GROUP_NODE_ENTITY_NAME,
            uniqueValue: groupNodeKey,
            groupElements: currentNodeEdgeMap
        };
    },
    createGraphDataWithGroupNode(myThis, groupNodeEdgeMap, allMaps) {
        myThis.graphData = {
            nodeMap: {},
            edgeMap: {}
        };
        if (groupNodeEdgeMap && groupNodeEdgeMap.nodeMap) {
            myThis.graphData.nodeMap = JSON.parse(JSON.stringify(groupNodeEdgeMap.nodeMap));
            myThis.graphData.edgeMap = JSON.parse(JSON.stringify(groupNodeEdgeMap.edgeMap));

            Object.keys(groupNodeEdgeMap.subEdgeMap).forEach(edge => {
                if (myThis.graphData.edgeMap[edge]) {
                    myThis.graphData.edgeMap = {
                        ...myThis.graphData.edgeMap,
                        ...groupNodeEdgeMap.subEdgeMap[edge]
                    };
                }
            });

            Object.keys(groupNodeEdgeMap.subNodeMap).forEach(edge => {
                if (myThis.graphData.edgeMap[edge]) {
                    myThis.graphData.nodeMap = {
                        ...myThis.graphData.nodeMap,
                        ...groupNodeEdgeMap.subNodeMap[edge]
                    };
                }
            });

            Object.keys(groupNodeEdgeMap.notDrawedEdgesMap).forEach(edge => {
                delete myThis.graphData.edgeMap[edge];
            });
        }
        if (allMaps) {
            Object.keys(allMaps.edgeMap).forEach(edgeKey => {
                if (allMaps.edgeMap[edgeKey].type == myThis.groupEdgeType) {
                    myThis.graphData.edgeMap[edgeKey] = allMaps.edgeMap[edgeKey];
                    myThis.graphData.nodeMap[allMaps.edgeMap[edgeKey].source] = allMaps.nodeMap[allMaps.edgeMap[edgeKey].source]
                    myThis.graphData.nodeMap[allMaps.edgeMap[edgeKey].target] = allMaps.nodeMap[allMaps.edgeMap[edgeKey].target]

                    if (allMaps.subEdgeMap[edgeKey]) {
                        myThis.graphData.edgeMap = {
                            ...myThis.graphData.edgeMap,
                            ...allMaps.subEdgeMap[edgeKey]
                        };
                    }
                    if (allMaps.subNodeMap[edgeKey]) {
                        myThis.graphData.nodeMap = {
                            ...myThis.graphData.nodeMap,
                            ...allMaps.subNodeMap[edgeKey]
                        };
                    }
                    Object.keys(allMaps.notDrawedEdgesMap).forEach(edge => {
                        delete myThis.graphData.edgeMap[edge];
                    });

                }
            });
        }
    },
    createEmptyNodeEdgeMap() {
        return {
            nodeMap: {},
            edgeMap: {},
            subEdgeMap: {},
            subNodeMap: {},
            notDrawedEdgesMap: {},
        };
    },
    getParameterFilterData(tabName, columnName, datatype, myThis) {
        if (datatype == constant.ATTR_DATA_TYPES.Parameter) {
            myThis.parameterDataMap = {};
            myThis.multiTableData[tabName].items.forEach(item => {
                myThis.parameterDataMap[item[columnName]] = true;
            });
        }
    },
    getExpandParameterFilterData(itemKeyStr, columnName, datatype, myThis) {
        if (datatype == constant.ATTR_DATA_TYPES.Parameter) {
            myThis.parameterDataMap = {};
            const rawItems = myThis.expandRawDataMap[itemKeyStr] || [];
            rawItems.forEach(item => {
                myThis.parameterDataMap[item[columnName]] = true;
            });
        }
    },
    applyColumnFilter(value, valueMax, operator, columnName, tabName, datatype, myThis) {
        let helperThis = this;
        if (!myThis.columnFilterMap[tabName]) {
            myThis.$set(myThis.columnFilterMap, tabName, {});
        }

        myThis.$set(myThis.columnFilterMap[tabName], columnName, {
            operator: operator,
            value: value,
            valueMax: valueMax,
            datatype: datatype
        });

        if (Object.keys(myThis.columnFilterMap[tabName]).length == 1) {
            myThis.filteredMultiTableData[tabName].items = myThis.multiTableData[tabName].items.filter(item => {
                return helperThis.filterColumnData(item[columnName], value, operator, valueMax, datatype);
            });
        } else {
            myThis.filteredMultiTableData[tabName].items = myThis.filteredMultiTableData[tabName].items.filter(item => {
                return helperThis.filterColumnData(item[columnName], value, operator, valueMax, datatype); //item[columnName] == value;
            });
        }
        myThis.getParameterFilterData(tabName, columnName, datatype);
        myThis.filteredMultiTableData[tabName] = JSON.parse(JSON.stringify(myThis.filteredMultiTableData[tabName]));
    },
    deleteColumnFilter(columnName, tabName, datatype, myThis) {
        let helperThis = this;
        if (myThis.columnFilterMap[tabName] && myThis.columnFilterMap[tabName][columnName]) {
            myThis.$delete(myThis.columnFilterMap[tabName], columnName);

            if (Object.keys(myThis.columnFilterMap[tabName]).length > 0) {
                let counter = 0;
                Object.keys(myThis.columnFilterMap[tabName]).forEach(column => {
                    if (counter == 0) {
                        myThis.filteredMultiTableData[tabName].items = myThis.multiTableData[tabName].items.filter(item => {
                            return helperThis.filterColumnData(
                                item[column],
                                myThis.columnFilterMap[tabName][column].value,
                                myThis.columnFilterMap[tabName][column].operator,
                                myThis.columnFilterMap[tabName][column].valueMax,
                                myThis.columnFilterMap[tabName][column].datatype
                            );
                        });
                    } else {
                        myThis.filteredMultiTableData[tabName].items = myThis.filteredMultiTableData[tabName].items.filter(
                            item => {
                                return helperThis.filterColumnData(
                                    item[column],
                                    myThis.columnFilterMap[tabName][column].value,
                                    myThis.columnFilterMap[tabName][column].operator,
                                    myThis.columnFilterMap[tabName][column].valueMax,
                                    myThis.columnFilterMap[tabName][column].datatype
                                );
                            }
                        );
                    }

                    counter++;
                });
            } else {
                if (tabName == 'scenario' || tabName == 'allScenario') {
                    myThis.filteredMultiTableData[tabName].items = JSON.parse(JSON.stringify(myThis.multiTableData[tabName].items));
                } else {
                    myThis.filteredMultiTableData[tabName] = JSON.parse(JSON.stringify(myThis.multiTableData[tabName]));
                }
            }
            myThis.getParameterFilterData(tabName, columnName, datatype);
        }
    },
    filterColumnData(item, value, operator, valueMax, datatype) {
        let tableThis = this;

        if (operator == "is null" || operator == "is not null") {
            switch (operator) {
                case "is null":
                    return item == "" || item == null || item == undefined;
                case "is not null":
                    return item != "" && item != null && item != undefined;
            }
        } else {
            if (item == null || item == undefined) {
                return false;
            }

            if (constant.lastDateOperator.indexOf(operator) > -1) {
                let lastDateInfo = tableThis.prepareFilterForLastDateOperator(value, operator, valueMax);

                operator = lastDateInfo.operator;
                value = lastDateInfo.value;
                valueMax = lastDateInfo.valueMax;
            }

            switch (operator) {
                case "=":
                    if (datatype == constant.ATTR_DATA_TYPES.String) {
                        return item.toString().toLocaleUpperCase("tr-TR") == value;
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) == value;
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item).toString() == value.toString();
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item).toString() == value.toString();
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Boolean) {
                        return item.toString() == value;
                    }
                case "!=":
                    if (datatype == constant.ATTR_DATA_TYPES.String) {
                        return item.toString().toLocaleUpperCase("tr-TR") != value;
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) != value;
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item).toString() != value.toString();
                    }
                    if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item).toString() != value.toString();
                    }
                case "not in":
                    let valueArray = value.split(",");
                    return valueArray.indexOf(item.toString().toLocaleUpperCase("tr-TR")) == -1;
                case "in":
                    let valueArray1 = value.split(",");
                    return valueArray1.indexOf(item.toString().toLocaleUpperCase("tr-TR")) > -1;
                case "starts with":
                    return item.toString().toLocaleUpperCase("tr-TR").startsWith(value);
                case "ends with":
                    return item.toString().toLocaleUpperCase("tr-TR").endsWith(value);
                case "contains":
                    return item.toString().toLocaleUpperCase("tr-TR").includes(value);
                case "not contains":
                    return !item.toString().toLocaleUpperCase("tr-TR").includes(value);
                case "<":
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) < value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item) < value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item) < value;
                    }
                case ">":
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) > value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item) > value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item) > value;
                    }
                case "between":
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) > value && parseFloat(item) < valueMax;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item) > value && tableThis.changeDateFormat(item) < valueMax;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item) > value && tableThis.changeDateTimeFormat(item) < valueMax;
                    }

                case "<=":
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) <= value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item) <= value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item) <= value;
                    }
                case ">=":
                    if (datatype == constant.ATTR_DATA_TYPES.Numeric || datatype == constant.ATTR_DATA_TYPES.Currency) {
                        return parseFloat(item) >= value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Date) {
                        return tableThis.changeDateFormat(item) >= value;
                    } else if (datatype == constant.ATTR_DATA_TYPES.Datetime) {
                        return tableThis.changeDateTimeFormat(item) >= value;
                    }
            }
        }
    },
    prepareFilterForLastDateOperator(value, operator, valueMax) {
        if (operator == "last day") {
            valueMax = moment().utc(false).subtract(value, "days")
        }
        else if (operator == "last month") {
            valueMax = moment().utc(false).subtract(value, "months")
        }
        else if (operator == "last year") {
            valueMax = moment().utc(false).subtract(value, "years")
        }
        else if (operator == "last hour") {
            valueMax = moment().utc(false).subtract(value, "hours")
        }
        else if (operator == "last minute") {
            valueMax = moment().utc(false).subtract(value, "minutes")
        }

        let lastDateInfo = {
            value: moment(valueMax).utc(false),
            operator: "between",
            valueMax: moment().utc(false)
        }

        return lastDateInfo;
    },
    tableItemsSort(items, isNumber, isDate, index, isDesc, isBool, isCurrency) {
        const sortIndex = index[0];
        const sortIsDesc = isDesc[0];
        items.sort((a, b) => {
            if ((isNumber || isBool) && !isNaN(a[sortIndex]) && !isNaN(b[sortIndex])) {
                if (a[sortIndex] != "-" && b[sortIndex] != "-") {
                    return sortIsDesc ? b[sortIndex] - a[sortIndex] : a[sortIndex] - b[sortIndex];
                } else if (a[sortIndex] == "-" && b[sortIndex] != "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (a[sortIndex] != "-" && b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                } else {
                    return 0;
                }
            } else if (isCurrency) {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    if (!sortIsDesc) {
                        return parseFloat(commonFunc.replaceAllWithoutReplaceAll(a[sortIndex].toString(), ",", ".")) - parseFloat(commonFunc.replaceAllWithoutReplaceAll(b[sortIndex].toString(), ",", "."));
                    } else {
                        return parseFloat(commonFunc.replaceAllWithoutReplaceAll(b[sortIndex].toString(), ",", ".")) - parseFloat(commonFunc.replaceAllWithoutReplaceAll(a[sortIndex].toString(), ",", "."));
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            } else if (isDate) {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    const aDay = a[sortIndex].substring(0, 10).split(".")[0];
                    const aMonth = a[sortIndex].substring(0, 10).split(".")[1];
                    const aYear = a[sortIndex].substring(0, 10).split(".")[2];
                    const aHour = a[sortIndex].substring(11, 20);

                    const bDay = b[sortIndex].substring(0, 10).split(".")[0];
                    const bMonth = b[sortIndex].substring(0, 10).split(".")[1];
                    const bYear = b[sortIndex].substring(0, 10).split(".")[2];
                    const bHour = b[sortIndex].substring(11, 20);

                    const aDate = `${aYear}-${aMonth}-${aDay} ${aHour}`;
                    const bDate = `${bYear}-${bMonth}-${bDay} ${bHour}`;

                    if (!sortIsDesc) {
                        return new Date(aDate) - new Date(bDate);
                    } else {
                        return new Date(bDate) - new Date(aDate);
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            } else {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    const aValue = String(a[sortIndex]);
                    const bValue = String(b[sortIndex]);
                    if (!sortIsDesc) {
                        return aValue.localeCompare(bValue);
                    } else {
                        return bValue.localeCompare(aValue);
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            }
        });
    },
    tableItemsSortForPreparedQuery(items, isNumber, isDate, index, isDesc, isBool, isCurrency) {
        const sortIndex = index;
        const sortIsDesc = isDesc;
        items.sort((a, b) => {
            if (isNumber || isBool) {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    return sortIsDesc ? b[sortIndex] - a[sortIndex] : a[sortIndex] - b[sortIndex];
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            } else if (isCurrency) {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    if (!sortIsDesc) {
                        return parseFloat(commonFunc.replaceAllWithoutReplaceAll(a[sortIndex].toString(), ",", ".")) - parseFloat(commonFunc.replaceAllWithoutReplaceAll(b[sortIndex].toString(), ",", "."));
                    } else {
                        return parseFloat(commonFunc.replaceAllWithoutReplaceAll(b[sortIndex].toString(), ",", ".")) - parseFloat(commonFunc.replaceAllWithoutReplaceAll(a[sortIndex].toString(), ",", "."));
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            } else if (isDate) {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    const aDay = a[sortIndex].substring(0, 10).split(".")[0];
                    const aMonth = a[sortIndex].substring(0, 10).split(".")[1];
                    const aYear = a[sortIndex].substring(0, 10).split(".")[2];
                    const aHour = a[sortIndex].substring(11, 20);

                    const bDay = b[sortIndex].substring(0, 10).split(".")[0];
                    const bMonth = b[sortIndex].substring(0, 10).split(".")[1];
                    const bYear = b[sortIndex].substring(0, 10).split(".")[2];
                    const bHour = b[sortIndex].substring(11, 20);

                    const aDate = `${aYear}-${aMonth}-${aDay} ${aHour}`;
                    const bDate = `${bYear}-${bMonth}-${bDay} ${bHour}`;

                    if (!sortIsDesc) {
                        return new Date(aDate) - new Date(bDate);
                    } else {
                        return new Date(bDate) - new Date(aDate);
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            } else {
                if (a[sortIndex] && b[sortIndex] && a[sortIndex] != "-" && b[sortIndex] != "-") {
                    const aValue = String(a[sortIndex]);
                    const bValue = String(b[sortIndex]);
                    if (!sortIsDesc) {
                        return aValue.localeCompare(bValue);
                    } else {
                        return bValue.localeCompare(aValue);
                    }
                } else if (!a[sortIndex] || a[sortIndex] == "-") {
                    return sortIsDesc ? -1 : 1;
                } else if (!b[sortIndex] || b[sortIndex] == "-") {
                    return sortIsDesc ? 1 : -1;
                }
            }
        });
    },
    changeDateFormat(date) {
        //TODO-ktolga: ana dili ingilizce olan bilgisayarlar için olan tarih sorunu çözüldüğünde buraya da uygulanmalı
        let dateArray = date.split(".");
        return new Date(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0]);
    },
    changeDateTimeFormat(date) {
        //TODO-ktolga: ana dili ingilizce olan bilgisayarlar için olan tarih sorunu çözüldüğünde buraya da uygulanmalı
        let dateArray = date.substring(0, 10).split(".");
        return new Date(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0] + " " + date.substring(11, 16));
    },
    convertGraphDataToTableData(graphData) {
        const tableGraphData = {
            key: "analysis0",
            from: "creator",
            data: {
                edgeMap: {},
                nodeMap: {},
            }
        };
        if (graphData && graphData.hasOwnProperty('nodeMap')) {
            const nodeKeys = Object.keys(graphData.nodeMap);
            const nodeArray = Object.values(graphData.nodeMap);
            nodeArray.forEach((node, index) => {
                const newNode = {};

                newNode.alias = node.alias;
                if (typeof node.alias === "string") {
                    newNode.alias = {
                        [node.type]: true
                    }
                }

                newNode.properties = {};
                const propertyKeys = Object.keys(node.properties);
                const propertiesArray = Object.values(node.properties);
                propertiesArray.forEach((property, i) => {
                    if (typeof property === "object") {
                        if (property && property.isVisible) {
                            newNode.properties[propertyKeys[i]] = property.value;
                        }
                    } else {
                        newNode.properties = node.properties;
                    }
                })

                newNode.id = node.id;
                newNode.label = node.label;
                newNode.visibleProps = [];
                newNode.uniqueValue = node.uniqueValue;
                newNode.type = node.type;

                tableGraphData.data.nodeMap[nodeKeys[index]] = newNode;
            })
            if (graphData && graphData.hasOwnProperty('edgeMap')) {
                tableGraphData.data.edgeMap = graphData.edgeMap;
            }
        }
        return tableGraphData;
    },
    isGroupableData(activeTab) {
        if (!localStorage.transferGroupData) {
            this.errorHandler("metaDataLoadError");
            return;
        }
        const allGroupEdges = JSON.parse(localStorage.transferGroupData);
        const filteredGroupEdge = Object.values(allGroupEdges).filter(
            (edge) => edge.baseEntityAliasListMap[1] == activeTab.value
        ).length;
        return filteredGroupEdge > 0
    },
    activeTabIsNode(activeTab) {
        if (!localStorage.transferGroupData) {
            this.errorHandler("metaDataLoadError");
            return;
        }
        const allGroupEdges = JSON.parse(localStorage.transferGroupData);
        const filteredGroupEdge = Object.values(allGroupEdges).filter(
            (edge) => edge.selectedBaseEntityAliasMap == activeTab.value
        ).length;
        return filteredGroupEdge > 0

    },
    createTableContents(data, col, stringLength) {
        let formattedData;
        if (data && data.length > stringLength) {
            if (col.datatype == constant.ATTR_DATA_TYPES.Currency) {
                formattedData = commonFunc.currencyFormatter(data).substring(0, stringLength) + "...";
            } else {
                formattedData = data.substring(0, stringLength) + "...";
            }
        } else if (data) {
            if (col.datatype == constant.ATTR_DATA_TYPES.Currency) {
                formattedData = commonFunc.currencyFormatter(data);
            } else {
                formattedData = data;
            }
        }
        return formattedData;
    },
    generateTableData(myThis) {
        const tabName = myThis.activeTabValue;
        if (!myThis.multiTableData[tabName]) {
            return [];
        }
        const tabData = this.searchGlobalTable(myThis, myThis.multiTableData[tabName].items, myThis.multiTableData[tabName].headers);
        const filters = myThis.columnFilterMap && myThis.columnFilterMap[tabName] ? myThis.columnFilterMap[tabName] : {};
        const filtersKeys = Object.keys(filters);
        const filteredData = tabData.filter(item => {
            for (const columnName of filtersKeys) {
                const { value, operator, valueMax, datatype } = filters[columnName];
                if (!this.filterColumnData(item[columnName], value, operator, valueMax, datatype)) {
                    return false;
                }
            }
            return true;
        });

        myThis.totalDataCount = filteredData.length;
        return myThis.updateDataSorting(tabName, filteredData);
    },
    customDataSort(items, isNumber, isDate, columnName, isDesc, isCurrency) {
        if (columnName === null || columnName === undefined) {
            return [...items];
        }
        return [...items].sort((a, b) => {

            if (isNumber) {
                const aValueRaw = a[columnName];
                const bValueRaw = b[columnName];
                const aValue = aValueRaw !== null ? parseFloat(aValueRaw) : null;
                const bValue = bValueRaw !== null ? parseFloat(bValueRaw) : null;
                const nullCheckResult = this.handleNullCheck(aValue, bValue, isDesc);
                if (nullCheckResult !== null) {
                    return nullCheckResult;
                }

                return this.getComparatorValue(aValue - bValue, isDesc);
            } else if (isCurrency) {
                const aValueRaw = a[columnName];
                const bValueRaw = b[columnName];
                const aValue = aValueRaw !== null ? parseFloat(commonFunc.replaceAllWithoutReplaceAll(aValueRaw.toString(), ",", ".")) : null;
                const bValue = bValueRaw !== null ? parseFloat(commonFunc.replaceAllWithoutReplaceAll(bValueRaw.toString(), ",", ".")) : null;
                const nullCheckResult = this.handleNullCheck(aValue, bValue, isDesc);
                if (nullCheckResult !== null) {
                    return nullCheckResult;
                }

                return this.getComparatorValue(aValue - bValue, isDesc);
            } else if (isDate) {
                const aValueRaw = a[columnName];
                const bValueRaw = b[columnName];
                const aValue = aValueRaw !== null ? this.parseDate(aValueRaw) : null;
                const bValue = bValueRaw !== null ? this.parseDate(bValueRaw) : null;

                const nullCheckResult = this.handleNullCheck(aValue, bValue, isDesc);
                if (nullCheckResult !== null) {
                    return nullCheckResult;
                }

                return this.getComparatorValue(aValue - bValue, isDesc);
            } else {
                const aValue = a[columnName];
                const bValue = b[columnName];
                const nullCheckResult = this.handleNullCheck(aValue, bValue, isDesc);
                if (nullCheckResult !== null) {
                    return nullCheckResult;
                }
                const aStr = String(aValue);
                const bStr = String(bValue);
                return this.getComparatorValue(aStr.localeCompare(bStr), isDesc);
            }
        });
    },
    handleNullCheck(aValue, bValue, isDesc) {
        if (aValue === null || bValue === null) {
            if (aValue === null && bValue === null) {
                return 0;
            } else if (aValue === null) {
                return isDesc ? 1 : -1;
            } else {
                return isDesc ? -1 : 1;
            }
        }
        return null;
    },
    getComparatorValue(value, isDesc) {
        if (!value || value === "-") {
            return isDesc ? 1 : -1;
        }
        return isDesc ? -value : value;
    },
    parseDate(formatedDate) {
        const [datePart, timePart] = formatedDate.split(" ");
        const dateParts = datePart.split(".");
        const [day, month, year] = dateParts;
        let hours = 0, minutes = 0, seconds = 0;
        if (timePart) {
            [hours, minutes, seconds] = timePart.split(":");
        }
        return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    searchGlobalTable(myThis, defaultData, headers) {
        const activeTab = myThis.activeTabValue;
        let searchKeyword = null;
        if (myThis.globalSearchMap && myThis.globalSearchMap[activeTab] && Object.keys(myThis.globalSearchMap[activeTab]).length > 0) {
            searchKeyword = myThis.globalSearchMap[activeTab].toLocaleLowerCase('tr-TR');
        }
        // Türkçe karakter problemi için
        if (!searchKeyword) {
            return defaultData;
        }

        return defaultData.filter(data => {
            return headers.some(header => { // sadece tabloda gösterilen objeleri filtrelesin. (headers Key kontrolü)
                const key = header.value;
                const value = data[key];

                if (typeof value === "string") {
                    return commonFunc.normalizeSearchValue(value, searchKeyword);
                }

                if (typeof value === "number") {
                    return String(value).includes(searchKeyword);
                }

                return false;
            });
        });
    },
    changeNumericParameterToString(properties, type, saveAsStringMap, parameterEntityMaps) {
        if (saveAsStringMap[type]) {
            Object.keys(saveAsStringMap[type]).forEach((attrName) => {
                const parameterFillEntityId = parameterEntityMaps[saveAsStringMap[type][attrName].fillEntityId];
                if (parameterFillEntityId) {
                    const parameterEntity = parameterFillEntityId.find((x) => x[saveAsStringMap[type][attrName].valueEntityAttributeName] == properties[attrName])
                    if (parameterEntity) {
                        properties[attrName] = commonFunc.deepCopy(parameterEntity[saveAsStringMap[type][attrName].textEntityAttributeName])
                    }
                }
            });
        }
    },
    resizableGrid(table, isSubTable) {
        const row = table.getElementsByTagName("tr")[0],
            cols = row ? Array.from(row.children) : undefined;
        if (!cols || cols.length === 0) return;

        table.style.overflow = "hidden";
        const rowHeight = row.offsetHeight;
        const eventListeners = [];
        if (cols[0]) {
            if (!isSubTable) {
                cols[0].style.width = "20px";
                cols[0].style.minWidth = "20px";
            } else {
                cols[0].style.width = "110px";
                cols[0].style.minWidth = "110px";
            }
            cols[0].style.maxWidth = "240px";
        }

        for (let i = 0; i < cols.length; i++) {
            const div = createDiv(rowHeight);
            cols[i].appendChild(div);
            setListeners(div, i);
        }

        function setListeners(div, colIndex) {
            let pageX, curCol, curColWidth, curColWidthUnit;
            const mouseDownListener = function (e) {
                curCol = cols[colIndex];
                pageX = e.pageX;

                curColWidth = parseFloat(curCol.style.width);
                curColWidthUnit = curCol.style.width.split(curColWidth)[1];
            };
            const mouseOverListener = function (e) {
                e.target.style.borderRight = "4px solid rgb(28, 54, 109, 0.2)";
            };
            const mouseOutListener = function (e) {
                e.target.style.borderRight = "";
            };
            const mouseMoveListener = function (e) {
                if (curCol) {
                    let diffX = e.pageX - pageX;
                    if (curColWidthUnit == "vw" || curColWidthUnit == "%") {
                        diffX = diffX / window.innerWidth * 100
                    }
                    const newWidth = curColWidth + diffX;
                    const calculatedWidth = newWidth + curColWidthUnit;
                    curCol.style.width = calculatedWidth;
                }
            };
            const mouseUpListener = function (e) {
                curCol = undefined;
                pageX = undefined;
                curColWidth = undefined;
            }
            div.addEventListener("mousedown", mouseDownListener);
            eventListeners.push({ target: div, eventName: "mousedown", listenerEvent: mouseDownListener })

            div.addEventListener("mouseover", mouseOverListener);
            eventListeners.push({ target: div, eventName: "mouseover", listenerEvent: mouseOverListener })

            div.addEventListener("mouseout", mouseOutListener);
            eventListeners.push({ target: div, eventName: "mouseout", listenerEvent: mouseOverListener })

            document.addEventListener("mousemove", mouseMoveListener);
            eventListeners.push({ target: document, eventName: "mousemove", listenerEvent: mouseMoveListener })

            document.addEventListener("mouseup", mouseUpListener);
            eventListeners.push({ target: document, eventName: "mouseup", listenerEvent: mouseUpListener })
        }
        function createDiv(height) {
            const div = document.createElement("div");
            div.style.top = 0;
            div.style.right = 0;
            div.style.width = "8px";
            div.style.position = "absolute";
            div.style.cursor = "e-resize";
            div.style.userSelect = "none";
            div.style.height = height - 1 + "px";
            div.style.backgroundColor = "var(--datatable-header-bg-color)";

            return div;
        }

        function paddingDiff(col) {
            if (getStyleVal(col, "box-sizing") == "border-box") {
                return 0;
            }

            const padLeft = getStyleVal(col, "padding-left");
            const padRight = getStyleVal(col, "padding-right");
            return parseInt(padLeft) + parseInt(padRight);
        }

        function getStyleVal(elm, css) {
            return window.getComputedStyle(elm, null).getPropertyValue(css);
        }
        return function removeListeners() {
            for (const listener of eventListeners) {
                listener.target.removeEventListener(listener.eventName, listener.listenerEvent);
            }
        }
    },
    customSort(headers, items, index, isDesc) {
        let isDate,
            isNumber = false,
            isBool = false;
        const sortHeader = headers.find(function (x) {
            return x.value == index[0];
        });
        if (sortHeader && (sortHeader.datatype == "Date" || sortHeader.datatype == "Datetime")) {
            isDate = true;
        } else if (sortHeader && sortHeader.datatype == "Numeric") {
            isNumber = true;
        } else if (sortHeader && sortHeader.datatype == "Boolean") {
            isBool = true;
        }
        if (sortHeader) {
            this.tableItemsSort(items, isNumber, isDate, index, isDesc, isBool);
        }
        return items;
    },
}
export default tableHelper;
